export default {
  namespaced: true,
  state: {

  },
  mutations: {
    /**
     * 设置字典
     * */
    setDict(state, code, data) {
      state.code = data
    },
  },
}
